import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OrangeSubmitButton } from '../../../../components/buttons/buttons';
import Colors from '../../../../styles/colors';

class VerificationCode extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.submitCode = this.submitCode.bind(this);
    this.resendCode= this.resendCode.bind(this);
  }

  onKeyDown(id, e) {
    const refs = this.refs;
    if (e.key === 'Backspace' || e.key === 'Delete') {
      return;
    }
    if (/\d/.test(e.key)) {
      // digits only
      setTimeout(() => refs['codeSign' + id].focus(), 50);
    } else {
      e.preventDefault();
    }
  }

  async submitCode() {
    const { codeSign1, codeSign2, codeSign3, codeSign4 } = this.refs;
    const verificationCode = codeSign1.value + codeSign2.value + codeSign3.value + codeSign4.value;
    await this.props.setVerificationCode(verificationCode);
    await this.props.submitCodeHandler();
  }

  async resendCode() {
    await this.props.resendCodeHandler();
  }

  render() {
    const {publisher, submitCode, resendCode} = this.props;
    return (
      <div
        style={{ padding: 20, textAlign: 'center' }}
        className="container-confirmation"
      >
        <div
          style={{ fontSize: 17 }}
          className="center-col text-center col-xs-8"
        >
          Almost there... to verify your ownership of the podcast, we sent a confirmation code to <br />
          <span style={{ color: Colors.mainOrange }}>{publisher.email}</span>
        </div>
        <div className="center-col text-center">
          <div style={{ paddingBottom: 18, fontSize: 21 }}>
            Enter the confirmation code:
          </div>
          <div>
            <input ref="codeSign1" onKeyDown={this.onKeyDown.bind(this, 2)} />
            <input ref="codeSign2" onKeyDown={this.onKeyDown.bind(this, 3)} />
            <input ref="codeSign3" onKeyDown={this.onKeyDown.bind(this, 4)} />
            <input ref="codeSign4" />
          </div>
        </div>
        <div style={{ marginTop: 20 }} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <OrangeSubmitButton
            styles={{ marginTop: 15, marginBottom: 15 }}
            label="Submit"
            onClick={this.submitCode.bind(this)}
          />
        </div>
        <div style={{ marginTop: 20 }} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <a style={{ color: Colors.link, marginLeft: 5 }} onClick={this.resendCode.bind(this)}>
            Resend the confirmation code
          </a>
        </div>
      </div>
    );
  }
}

VerificationCode.propTypes = {
  publisher: PropTypes.object,
  submitCodeHandler: PropTypes.func,
  resendCodeHandler: PropTypes.func,
};

VerificationCode.defaultProps = {
  publisher: {},
  submitCodeHandler: () => {},
  resendCodeHandler: () => {},
};

export default VerificationCode;
